import React, { useCallback, useMemo } from 'react';
import TypographyAutocomplete from '../TypographyAutocomplete';

type Props = {
	fontFamilies: string[];
	values: Record<string, string>;
	setVariant: (path: string, value: string) => void;
};

export default ({ fontFamilies, values, setVariant }: Props) => {
	const fontFamilyOptions = useMemo(
		() => fontFamilies?.map((_, i) => i.toString()) || [],
		[fontFamilies]
	);

	const setFontFamily = useCallback(
		(v: string) => setVariant('font-family', v),
		[setVariant]
	);

	const getFontFamilyLabel = useCallback(
		(v: string) => fontFamilies[Number(v)],
		[fontFamilies]
	);

	const renderOption = useCallback(
		(props: {}, option: string) => (
			<span {...props} key={option}>
				{fontFamilies[Number(option)]}
			</span>
		),
		[fontFamilies]
	);

	return (
		<TypographyAutocomplete
			label={intl.tr('styleEditor.typography.variant.font.family')}
			value={values['font-family']}
			options={fontFamilyOptions}
			getOptionLabel={getFontFamilyLabel}
			setValue={setFontFamily}
			renderOption={renderOption}
			data-testid="typography-variant-font-family"
		/>
	);
};
